import { createSlice } from '@reduxjs/toolkit';

export interface SidebarState {
  visibility: 'show' | 'hidden';
  isActive: boolean;
  companySlug: string;
}

const initialState: SidebarState = {
  visibility: 'show',
  isActive: true,
  companySlug: '',
};

const sidebarSlice = createSlice({
  name: 'Sidebar',
  initialState,
  reducers: {
    changeSidebarVisibility(state, action) {
      state.visibility = action.payload;
    },
    setIsCompanyActivated(state, action) {
      state.isActive = action.payload;
    },
    setCompanySlug(state, action) {
      state.companySlug = action.payload;
    },
  },
});

export const { changeSidebarVisibility, setIsCompanyActivated, setCompanySlug } = sidebarSlice.actions;

export default sidebarSlice.reducer;
